// PRD.275 — Elia AI Assistant Drawer (Phase 1, UI only).
//
// Elia has its own pink brand identity, distinct from the app's blue primary
// token. These values are lifted directly from the approved Figma frame
// (node 885:3153) and are intentionally self-contained so Elia's look does not
// depend on per-client brand theming.

export const ELIA_COLORS = {
  /** Elia accent — pink/magenta. */
  pink: '#f764ba',
  /** Soft pink used for the context banner surface. */
  pinkSoft: '#f5dae6',
  /** Neutral incoming-bubble / input surface. */
  neutralSurface: '#f3f4f6',
  surface: '#ffffff',
  border: '#e5e7eb',
  borderSubtle: '#f3f4f6',
  text: '#111827',
  textSecondary: '#374151',
  textMuted: '#6b7280',
  textFaint: '#9ca3af',
  checkboxBorder: '#d1d5db',
} as const;

export const ELIA_FONT = 'var(--font-family, Inter, ui-sans-serif, system-ui, sans-serif)';

/** Docked drawer width on wide desktop (~380–400px per Figma). */
export const ELIA_DRAWER_WIDTH = 384;

/** Above the app shell and existing overlays (app uses 9999 for drawers). */
export const ELIA_Z_INDEX = 10000;

// Responsive breakpoints (px):
//   width < mobileMax          → full-screen conversation
//   mobileMax ≤ width < wideMin → right-side overlay + backdrop
//   width ≥ wideMin            → fixed docked drawer, page stays usable
export const ELIA_BREAKPOINTS = {
  mobileMax: 640,
  wideMin: 1280,
} as const;

export type EliaLayoutMode = 'mobile' | 'overlay' | 'docked';

export function resolveEliaLayoutMode(viewportWidth: number): EliaLayoutMode {
  if (viewportWidth < ELIA_BREAKPOINTS.mobileMax) return 'mobile';
  if (viewportWidth < ELIA_BREAKPOINTS.wideMin) return 'overlay';
  return 'docked';
}
